'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSessionId = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSessionId = exports.getSessionId = (0, _get2.default)('sessionId');


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/widget-data/getSessionId.js
// module id = 1075
// module chunks = 2 3